const memo1 = {
  id: 1,
  passage: `Subject: Q2 <mark>Budget</mark> <mark>Adjustments</mark> - Action Required
To: Department Managers
From: Finance Department
Date: April 1, 2025

As we approach the second quarter, we are implementing budget adjustments to <mark>align with</mark> our company's <mark>revised</mark> financial strategy. Based on our latest <mark>projections</mark>, departmental budgets for Q2 will be adjusted by 5% to optimize resource <mark>allocation</mark>.

Key Requirements:

Due Date: April 15, 2025
Required Documents:
- Revised breakdown of <mark>essential</mark> vs. non-essential expenses
- <mark>Justifications</mark> for critical <mark>expenditures</mark> exceeding adjusted limit
- Cost-saving <mark>initiatives</mark> report

Budget approval will be completed by April 22, 2025, with implementation starting May 1, 2025. Additional funding requests must go through formal approval process.

For questions, contact Finance Department at finance@company.com.

Best regards,
Finance Department`,

  translation: `제목: 2분기 예산 조정 - 조치 필요
수신: 부서 관리자
발신: 재무부
날짜: 2025년 4월 1일

2분기를 앞두고 회사의 수정된 재무 전략에 맞춰 예산 조정을 실시합니다. 최신 전망에 따라 자원 배분 최적화를 위해 2분기 부서별 예산이 5% 조정될 예정입니다.

주요 요구사항:

제출기한: 2025년 4월 15일
필수 제출 서류:
- 필수 vs 비필수 지출 항목 수정 내역
- 조정된 한도 초과 주요 지출 정당성 설명
- 비용 절감 계획 보고서

예산 승인은 4월 22일까지 완료되며, 수정된 예산은 5월 1일부터 적용됩니다. 조정된 예산 외 추가 자금 요청은 공식 승인 절차를 통해 제출해야 하며 건별로 검토됩니다.

문의사항은 재무부(finance@company.com)로 연락 바랍니다.

감사합니다.
재무부`,

  koreanNouns: `Subject: Q2 <mark>예산</mark> <mark>조정</mark> - Action Required
To: Department Managers
From: Finance Department
Date: April 1, 2025

As we approach the second quarter, we are implementing budget adjustments to <mark>맞춰</mark> our company's <mark>수정된</mark> financial strategy. Based on our latest <mark>전망</mark>, departmental budgets for Q2 will be adjusted by 5% to optimize resource <mark>배분</mark>.

Key Requirements:

Due Date: April 15, 2025
Required Documents:
- Revised breakdown of <mark>필수</mark> vs. non-essential expenses
- <mark>정당성</mark> for critical <mark>지출</mark> exceeding adjusted limit
- Cost-saving <mark>계획</mark> report

Budget approval will be completed by April 22, 2025, with implementation starting May 1, 2025. Additional funding requests must go through formal approval process.

For questions, contact Finance Department at finance@company.com.

Best regards,
Finance Department`,

  wordPairs: {
    budget: "예산",
    adjustments: "조정",
    "align with": "맞춰",
    revised: "수정된",
    projections: "전망",
    allocation: "배분",
    essential: "필수",
    justifications: "정당성",
    expenditures: "지출",
    initiatives: "계획",
  },

  questions: [],
};

const memo2 = {
  id: 2,
  passage: `Subject: Workplace Safety Training – <mark>Mandatory</mark> for All Employees
To: All Staff Members
From: Human Resources Department
Date: July 12, 2025

As part of our company's workplace safety <mark>initiative</mark>, all employees are required to attend a mandatory safety training session.

Training Details:

Date: Tuesday, July 16
Time: 9:00 AM – 11:00 AM
Location: Main Auditorium
<mark>Attendance</mark> is mandatory, and employees who fail to complete this training will not be permitted to access <mark>certain</mark> areas of the workplace.

If you have any scheduling conflicts, please contact HR at hr@company.com before July 14.`,

  translation: `제목: 직장 안전 교육 - 전 직원 필수 참석
수신: 전 직원
발신: 인사부
날짜: 2025년 7월 12일

회사의 직장 안전 계획의 일환으로, 모든 직원은 필수 안전 교육 세션에 참석해야 합니다.

교육 세부사항:

날짜: 7월 16일 화요일
시간: 오전 9시 - 오전 11시
장소: 본 강당
참석은 필수이며, 이 교육을 이수하지 않은 직원은 직장 내 특정 구역에 출입이 제한됩니다.

일정 충돌이 있는 경우, 7월 14일까지 인사부(hr@company.com)로 연락 주시기 바랍니다.`,

  koreanNouns: `Subject: Workplace Safety Training – <mark>필수</mark> for All Employees
To: All Staff Members
From: Human Resources Department
Date: July 12, 2025

As part of our company's workplace safety <mark>조치</mark>, all employees are required to attend a mandatory safety training session.

Training Details:

Date: Tuesday, July 16
Time: 9:00 AM – 11:00 AM
Location: Main Auditorium
<mark>참석</mark> is mandatory, and employees who fail to complete this training will not be permitted to access <mark>특정</mark> areas of the workplace.

If you have any scheduling conflicts, please contact HR at hr@company.com before July 14.`,

  wordPairs: {
    필수: "Mandatory",
    조치: "initiative",
    참석: "Attendance",
    특정: "certain",
  },

  questions: [],
};

const memo3 = {
  id: 3,
  passage: `Subject: Request for Budget Approval – Q3 Marketing Campaign
To: Mr. Andrew Johnson, Finance Director
From: Emily Carter, Marketing Manager
Date: September 5, 2025

Dear Mr. Johnson,

I am writing to request your approval for the budget allocation for our upcoming Q3 Marketing Campaign. The detailed proposal and estimated costs are attached for your review.

Key Highlights:

Total Budget Requested: $75,000
Campaign Duration: October 1 – December 31
Expected Outcomes: Increased brand <mark>awareness</mark> and customer engagement
Please let me know if you require any <mark>modifications</mark> or additional information. I would appreciate your approval by September 10 to ensure the campaign proceeds as planned.

Best regards,
Emily Carter`,

  translation: `제목: 예산 승인 요청 - 3분기 마케팅 캠페인
수신: 앤드류 존슨 재무 이사님
발신: 에밀리 카터, 마케팅 매니저
날짜: 2025년 9월 5일

존슨 이사님께,

다가오는 3분기 마케팅 캠페인을 위한 예산 배정에 대한 승인을 요청드립니다. 검토를 위해 상세 제안서와 예상 비용을 첨부하였습니다.

주요 내용:

총 요청 예산: 75,000달러
캠페인 기간: 10월 1일 - 12월 31일
기대 성과: 브랜드 인지도 및 고객 참여도 증가
수정이나 추가 정보가 필요하시다면 알려주시기 바랍니다. 계획대로 캠페인을 진행하기 위해 9월 10일까지 승인해 주시면 감사하겠습니다.

감사합니다.
에밀리 카터 드림`,
  koreanNouns: `Subject: Request for Budget Approval – Q3 Marketing Campaign
To: Mr. Andrew Johnson, Finance Director
From: Emily Carter, Marketing Manager
Date: September 5, 2025

Dear Mr. Johnson,

I am writing to request your approval for the budget allocation for our upcoming Q3 Marketing Campaign. The detailed proposal and estimated costs are attached for your review.

Key Highlights:

Total Budget Requested: $75,000
Campaign Duration: October 1 – December 31
Expected Outcomes: Increased brand <mark>인지도</mark> and customer engagement
Please let me know if you require any <mark>수정</mark> or additional information. I would appreciate your approval by September 10 to ensure the campaign proceeds as planned.

Best regards,
Emily Carter`,

  wordPairs: {
    awareness: "인지도",
    modifications: "수정",
  },

  questions: [],
};

const memo4 = {
  id: 4,
  passage: `Subject: Upcoming Business Trip – Sales Team
To: Sales Team Members
From: Jacob Stevens, Regional Sales Director
Date: October 3, 2025

Dear Team,

As part of our <mark>ongoing efforts</mark> to expand <mark>market reach</mark>, the sales team will be traveling to Chicago next month to attend the Annual <mark>Retail</mark> Conference 2025.

Business Trip Details:

Date: October 15 – October 18
Location: Grand Expo Center, Chicago, IL
Purpose: Networking, market research, and business development
Action Required:

Flight and hotel reservations will be arranged by the company. Please confirm your availability by October 7.
A detailed <mark>itinerary</mark> and meeting schedule will be shared one week prior to departure.
Employees attending the conference are expected to submit a <mark>trip report</mark> by October 25.
If you have any questions or scheduling conflicts, please reach out to hr@company.com.

Best regards,
Jacob Stevens`,

  translation: `제목: 예정된 출장 - 영업팀
수신: 영업팀 직원
발신: 제이콥 스티븐스, 지역 영업 이사
날짜: 2025년 10월 3일

팀원 여러분,

시장 확대를 위한 지속적인 노력의 일환으로, 영업팀은 다음 달 2025 연례 소매 컨퍼런스 참석을 위해 시카고로 출장을 갈 예정입니다.

출장 세부사항:

날짜: 10월 15일 - 10월 18일
장소: 그랜드 엑스포 센터, 시카고, 일리노이
목적: 네트워킹, 시장 조사, 사업 개발

필요한 조치:

항공편과 호텔 예약은 회사에서 진행합니다. 10월 7일까지 참석 가능 여부를 확인해 주시기 바랍니다.
상세 일정과 회의 일정은 출발 1주일 전에 공유될 예정입니다.
컨퍼런스 참석자는 10월 25일까지 출장 보고서를 제출해야 합니다.
문의사항이나 일정 충돌이 있으시면 hr@company.com으로 연락 주시기 바랍니다.

감사합니다.
제이콥 스티븐스 드림`,

  koreanNouns: `Subject: Upcoming Business Trip – Sales Team
To: Sales Team Members
From: Jacob Stevens, Regional Sales Director
Date: October 3, 2025

Dear Team,

As part of our <mark>지속적인 노력</mark> to expand <mark>시장 점유율</mark>, the sales team will be traveling to Chicago next month to attend the Annual <mark>소매</mark> Conference 2025.

Business Trip Details:

Date: October 15 – October 18
Location: Grand Expo Center, Chicago, IL
Purpose: Networking, market research, and business development

Action Required:

Flight and hotel reservations will be arranged by the company. Please confirm your availability by October 7.
A detailed <mark>여정</mark> and meeting schedule will be shared one week prior to departure.
Employees attending the conference are expected to submit a <mark>출장 보고서</mark> by October 25.
If you have any questions or scheduling conflicts, please reach out to hr@company.com.

Best regards,
Jacob Stevens`,

  wordPairs: {
    "지속적인 노력": "ongoing efforts",
    "시장 점유율": "market reach",
    소매: "retail",
    여정: "itinerary",
    "출장 보고서": "trip report",
  },

  questions: [],
};

const memo5 = {
  id: 5,
  passage: `Subject: <mark>Mandatory</mark> Team Meeting – Project Update
To: All Project Team Members
From: Rachel Adams, Project Manager
Date: June 20, 2025

Dear Team,

Please be reminded that our monthly project review meeting will be held next week. Your <mark>attendance</mark> is mandatory, as we will be discussing key project <mark>milestones</mark> and upcoming deadlines.

Meeting Details:

Date: Tuesday, June 25
Time: 10:00 AM – 11:30 AM
Location: Conference Room B

<mark>Agenda</mark> Highlights:

Status updates on ongoing tasks
Discussion of <mark>challenges</mark> and solutions
Finalizing the Q3 project timeline
If you are unable to attend, please notify me by June 23 and provide an update on your current <mark>assignments</mark>.

Thank you for your cooperation.

Best,
Rachel Adams`,

  translation: `제목: 필수 팀 회의 - 프로젝트 업데이트
수신: 모든 프로젝트 팀원
발신: 레이첼 아담스, 프로젝트 매니저
날짜: 2025년 6월 20일

팀원 여러분,

다음 주에 월간 프로젝트 검토 회의가 있음을 상기시켜 드립니다. 주요 프로젝트 이정표와 다가오는 마감일에 대해 논의할 예정이므로 참석은 필수입니다.

회의 세부사항:

날짜: 6월 25일 화요일
시간: 오전 10시 - 오전 11시 30분
장소: 회의실 B

안건 주요내용:

진행 중인 업무 현황 업데이트
문제점과 해결방안 논의
3분기 프로젝트 일정 확정
참석이 어려우신 경우, 6월 23일까지 알려주시고 현재 담당 업무에 대한 업데이트를 제공해 주시기 바랍니다.

협조해 주셔서 감사합니다.

감사합니다.
레이첼 아담스 드림`,

  koreanNouns: `Subject: Mandatory Team Meeting – Project Update
To: All Project Team Members
From: Rachel Adams, Project Manager
Date: June 20, 2025

Dear Team,

Please be reminded that our monthly project review meeting will be held next week. Your <mark>참석</mark> is <mark>필수</mark>, as we will be discussing key project <mark>이정표</mark> and upcoming deadlines.

Meeting Details:

Date: Tuesday, June 25
Time: 10:00 AM – 11:30 AM
Location: Conference Room B

<mark>안건</mark> Highlights:

Status updates on ongoing tasks
Discussion of <mark>문제점</mark> and solutions
Finalizing the Q3 project timeline
If you are unable to attend, please notify me by June 23 and provide an update on your current <mark>업무</mark>.

Thank you for your cooperation.

Best,
Rachel Adams`,

  wordPairs: {
    참석: "attendance",
    필수: "Mandatory",
    이정표: "milestones",
    안건: "Agenda",
    문제점: "challenges",
    업무: "assignments",
  },

  questions: [],
};

const memo6 = {
  id: 6,
  passage: `Subject: Scheduled Equipment <mark>Maintenance</mark> – IT Department
To: All Employees
From: IT Support Team
Date: August 10, 2025

Dear Employees,

Please be informed that scheduled maintenance will be performed on the company's network servers and IT equipment next week. During this time, access to company systems may be temporarily <mark>unavailable</mark>.

<mark>Maintenance</mark> Schedule:

Date: Saturday, August 17
Time: 8:00 AM – 2:00 PM
Affected Services: Email, shared drives, internal messaging system

Important Information:

Employees are advised to back up important files before August 16.
Urgent IT-related tasks should be completed before the maintenance period.
Normal system operations will resume by 3:00 PM on August 17.
If you experience any issues after the maintenance, please contact it.support@company.com.

Thank you for your understanding.

Best regards,
IT Support Team`,

  translation: `제목: 예정된 장비 점검 - IT 부서
수신: 전 직원
발신: IT 지원팀
날짜: 2025년 8월 10일

직원 여러분,

다음 주에 회사의 네트워크 서버와 IT 장비에 대한 예정된 점검이 실시될 예정임을 알려드립니다. 이 기간 동안 회사 시스템 접속이 일시적으로 불가능할 수 있습니다.

점검 일정:

날짜: 8월 17일 토요일
시간: 8:00 AM – 2:00 PM
영향 받는 서비스: 이메일, 공유 드라이브, 내부 메시징 시스템

중요 정보:

직원들은 8월 16일 이전에 중요 파일을 백업하시기 바랍니다.
긴급한 IT 관련 업무는 점검 기간 전에 완료되어야 합니다.
정상적인 시스템 운영은 8월 17일 오후 3시까지 재개될 예정입니다.
점검 후 문제가 발생하면 it.support@company.com으로 연락 주시기 바랍니다.

양해해 주셔서 감사합니다.

감사합니다.
IT 지원팀 드림`,
  koreanNouns: `Subject: Scheduled Equipment <mark>점검</mark> – IT Department
To: All Employees
From: IT Support Team
Date: August 10, 2025

Dear Employees,

Please be informed that scheduled maintenance will be performed on the company's network servers and IT equipment next week. During this time, access to company systems may be temporarily <mark>불가능할</mark>.

<mark>점검</mark> Schedule:

Date: Saturday, August 17
Time: 8:00 AM – 2:00 PM
Affected Services: Email, shared drives, internal messaging system

Important Information:

Employees are advised to back up important files before August 16.
Urgent IT-related tasks should be completed before the maintenance period.
Normal system operations will resume by 3:00 PM on August 17.
If you experience any issues after the maintenance, please contact it.support@company.com.

Thank you for your understanding.

Best regards,
IT Support Team`,

  wordPairs: {
    Maintenance: "점검",
    unavailable: "불가능할",
  },

  questions: [],
};
const memo7 = {
  id: 7,
  passage: `Subject: Announcement of Staff Promotion and Department Transfers
To: All Employees
From: Human Resources Department
Date: September 1, 2025

Dear Team,

We are pleased to announce the following staff promotions and department transfers, effective September 15, 2025.

Promotions:

Ms. Olivia Clark has been promoted to Senior Marketing Manager. She has played a key role in developing successful advertising campaigns and will now <mark>oversee</mark> the entire marketing team.
Mr. James Porter will <mark>assume</mark> the role of Finance Director. With over 10 years of experience, he has demonstrated <mark>exceptional</mark> leadership in financial planning and operations.

Department Transfers:

Mr. Ethan Collins will transfer from Customer Support to Sales Department to strengthen our client relations team.
Ms. Sophia Lee will move from IT Support to Project Management.
We appreciate their hard work and dedication, and we look forward to their continued <mark>contributions</mark> in their new roles. Please join us in congratulating them!

Best regards,
HR Department`,

  translation: `제목: 직원 승진 및 부서 이동 공지
수신: 전 직원
발신: 인사부
날짜: 2025년 9월 1일

팀원 여러분,

2025년 9월 15일부터 적용되는 다음의 직원 승진 및 부서 이동을 발표하게 되어 기쁩니다.

승진:

올리비아 클라크 님이 수석 마케팅 매니저로 승진하였습니다. 그녀는 성공적인 광고 캠페인 개발에 핵심적인 역할을 해왔으며, 이제 전체 마케팅 팀을 총괄하게 됩니다.
제임스 포터 님이 재무 이사직을 맡게 됩니다. 10년 이상의 경험을 바탕으로 재무 계획과 운영에서 탁월한 리더십을 보여주었습니다.

부서 이동:

이든 콜린스 님이 고객 지원팀에서 영업부로 이동하여 고객 관리팀을 강화할 예정입니다.
소피아 리 님이 IT 지원팀에서 프로젝트 관리팀으로 이동합니다.
이들의 열정과 헌신에 감사드리며, 새로운 역할에서의 지속적인 기여를 기대합니다. 축하해 주시기 바랍니다!

감사합니다.
인사부 드림`,
  koreanNouns: `Subject: Announcement of Staff Promotion and Department Transfers
To: All Employees
From: Human Resources Department
Date: September 1, 2025

Dear Team,

We are pleased to announce the following staff promotions and department transfers, effective September 15, 2025.

Promotions:

Ms. Olivia Clark has been promoted to Senior Marketing Manager. She has played a key role in developing successful advertising campaigns and will now <mark>총괄하다</mark> the entire marketing team.
Mr. James Porter will <mark>맡다</mark> the role of Finance Director. With over 10 years of experience, he has demonstrated <mark>탁월한</mark> leadership in financial planning and operations.

Department Transfers:

Mr. Ethan Collins will transfer from Customer Support to Sales Department to strengthen our client relations team.
Ms. Sophia Lee will move from IT Support to Project Management.
We appreciate their hard work and dedication, and we look forward to their continued <mark>기여</mark> in their new roles. Please join us in congratulating them!

Best regards,
HR Department`,

  wordPairs: {
    "직원 승진": "staff promotions",
    총괄하다: "oversee",
    맡다: "assume",
    탁월한: "exceptional",
    기여: "contributions",
  },

  questions: [],
};

const memo8 = {
  id: 8,
  passage: `Subject: Annual Leave Request Process – 2025
To: All Employees
From: Human Resources Department
Date: November 1, 2025

Dear Employees,

As we approach the end of the year, we would like to remind everyone to submit their <mark>annual leave</mark> requests in advance to ensure proper scheduling.

Leave Request Guidelines:

Employees must submit their requests at least two weeks in advance.
Requests should be sent <mark>via</mark> the HR portal at www.hrportal.com.
Approval <mark>is subject to</mark> workload and department <mark>staffing needs</mark>.

Important Notes:

Leave requests during peak business periods may be limited.
Any changes to approved leave must be reported to the HR department immediately.
Unused <mark>annual leave</mark> cannot be <mark>carried over</mark> to the next year.
If you have any questions, please contact hr@company.com.

Best regards,
HR Department`,

  translation: `제목: 연차 휴가 신청 절차 - 2025
수신: 전 직원
발신: 인사부
날짜: 2025년 11월 1일

직원 여러분,

연말이 다가옴에 따라, 적절한 일정 관리를 위해 연차 휴가 신청을 미리 제출해 주시기를 상기시켜 드립니다.

휴가 신청 지침:

직원들은 최소 2주 전에 신청서를 제출해야 합니다.
신청은 HR 포털(www.hrportal.com)을 통해 제출되어야 합니다.
승인은 업무량과 부서 인력 필요에 따라 결정됩니다.

중요 사항:

성수기 기간 동안의 휴가 신청은 제한될 수 있습니다.
승인된 휴가의 변경 사항은 즉시 인사부에 보고되어야 합니다.
미사용 연차는 다음 해로 이월될 수 없습니다.
문의사항이 있으시면 hr@company.com으로 연락 주시기 바랍니다.

감사합니다.
인사부 드림`,

  koreanNouns: `Subject: <mark>연차 휴가</mark> Request Process – 2025
To: All Employees
From: Human Resources Department
Date: November 1, 2025

Dear Employees,

As we approach the end of the year, we would like to remind everyone to submit their <mark>연차 휴가</mark> requests in advance to ensure proper scheduling.

Leave Request Guidelines:

Employees must submit their requests at least two weeks in advance.
Requests should be sent <mark>통해</mark> the HR portal at www.hrportal.com.
Approval <mark>따라 결정됩니다</mark> workload and department <mark>인력 필요</mark>.

Important Notes:

Leave requests during peak business periods may be limited.
Any changes to approved leave must be reported to the HR department immediately.
Unused <mark>연차 휴가</mark> cannot be <mark>이월</mark> to the next year.
If you have any questions, please contact hr@company.com.

Best regards,
HR Department`,

  wordPairs: {
    "annual leave": "연차 휴가",
    via: "통해",
    "is subject to": "따라 결정됩니다",
    "staffing needs": "인력 필요",
    "carried over": "이월",
  },

  questions: [],
};

const memo9 = {
  id: 9,
  passage: `Subject: Update to Remote Work Policy
To: All Employees
From: Management Team
Date: March 10, 2025

Dear Team,

We would like to inform you of an important update to the company's <mark>remote work policy</mark>, which will take effect starting April 1, 2025.

Key Changes:

Employees may now work <mark>remotely</mark> up to three days per week, <mark>subject to</mark> manager approval.
All remote work requests must be submitted at least one week in advance.
Employees working <mark>remotely</mark> are expected to be available during <mark>regular business hours</mark> and must use the company's <mark>secure</mark> VPN for data access.

Action Required:

Please review the updated policy document on the company intranet.
Managers will provide <mark>further</mark> details during next week's department meetings.
Employees with questions or concerns may contact hr@company.com.
We appreciate your cooperation in <mark>implementing</mark> this new policy.

Best regards,
Management Team`,

  translation: `제목: 재택근무 정책 업데이트
수신: 전 직원
발신: 경영진
날짜: 2025년 3월 10일

팀원 여러분,

2025년 4월 1일부터 시행될 회사의 재택근무 정책 변경사항을 알려드립니다.

주요 변경사항:

직원들은 관리자 승인 하에 주당 최대 3일까지 재택근무가 가능합니다.
모든 재택근무 신청은 최소 1주일 전에 제출되어야 합니다.
재택근무 직원은 정규 근무시간 동안 연락 가능해야 하며, 데이터 접근 시 회사의 보안 VPN을 사용해야 합니다.

필요한 조치:

회사 인트라넷에서 업데이트된 정책 문서를 검토해 주시기 바랍니다.
다음 주 부서 회의에서 관리자가 추가 세부사항을 안내할 예정입니다.
문의사항이나 우려사항이 있는 직원은 hr@company.com으로 연락 주시기 바랍니다.
새로운 정책 시행에 협조해 주셔서 감사합니다.

감사합니다.
경영진 드림`,

  koreanNouns: `Subject: Update to <mark>재택근무 정책</mark>
To: All Employees
From: Management Team
Date: March 10, 2025

Dear Team,

We would like to inform you of an important update to the company's <mark>재택근무 정책</mark>, which will take effect starting April 1, 2025.

Key Changes:

Employees may now work <mark>재택으로</mark> up to three days per week, <mark>에 따라</mark> manager approval.
All remote work requests must be submitted at least one week in advance.
Employees working <mark>재택으로</mark> are expected to be available during <mark>정규 근무시간</mark> and must use the company's <mark>보안</mark> VPN for data access.

Action Required:

Please review the updated policy document on the company intranet.
Managers will provide <mark>추가</mark> details during next week's department meetings.
Employees with questions or concerns may contact hr@company.com.
We appreciate your cooperation in <mark>시행하는</mark> this new policy.

Best regards,
Management Team`,

  wordPairs: {
    "Remote Work Policy": "재택근무 정책",
    "remote work policy": "재택근무 정책",
    remotely: "재택으로",
    "subject to": "에 따라",
    "regular business hours": "정규 근무시간",
    secure: "보안",
    further: "추가",
    implementing: "시행하는",
  },

  questions: [],
};

const memo10 = {
  id: 10,
  passage: `Subject: Annual <mark>Employee Appreciation</mark> Event
To: All Employees
From: Human Resources Department
Date: April 5, 2025

Dear Team,

We are excited to invite you to our Annual <mark>Employee Appreciation</mark> Event, where we celebrate the hard work and <mark>dedication</mark> of our employees.

Event Details:

Date: Friday, April 19, 2025
Time: 6:00 PM – 10:00 PM
Venue: Grand Ballroom, Hilton Hotel

Highlights of the Evening:
✔ Award ceremony recognizing <mark>outstanding</mark> employees
✔ Dinner and <mark>live entertainment</mark>
✔ <mark>Lucky draw</mark> with exciting prizes

Important Notes:

Attendance is free, but employees must <mark>RSVP</mark> by April 12 at events@company.com.
Employees may <mark>bring</mark> one guest.
<mark>Business casual attire</mark> is required.
We look forward to celebrating with you! If you have any questions, please contact the HR department.

Best regards,
HR Department`,

  translation: `제목: 연례 직원 감사 행사
수신: 전 직원
발신: 인사부
날짜: 2025년 4월 5일

팀원 여러분,

직원들의 노고와 헌신을 기념하는 연례 직원 감사 행사에 여러분을 초대하게 되어 기쁩니다.

행사 세부사항:

날짜: 2025년 4월 19일 금요일
시간: 오후 6시 - 오후 10시
장소: 힐튼 호텔 그랜드 볼룸

저녁 행사 하이라이트:
✔ 우수 직원 시상식
✔ 만찬과 라이브 공연
✔ 푸짐한 경품 추첨

중요 사항:

참석은 무료이나, 4월 12일까지 events@company.com으로 참석 여부를 알려주셔야 합니다.
직원 1인당 게스트 1명을 동반할 수 있습니다.
비즈니스 캐주얼 복장이 요구됩니다.
여러분과 함께 축하하기를 기대합니다! 문의사항이 있으시면 인사부로 연락 주시기 바랍니다.

감사합니다.
인사부 드림`,

  koreanNouns: `Subject: Annual <mark>직원 감사</mark> Event
To: All Employees
From: Human Resources Department
Date: April 5, 2025

Dear Team,

We are excited to invite you to our Annual Employee Appreciation Event, where we celebrate the hard work and <mark>헌신</mark> of our employees.

Event Details:

Date: Friday, April 19, 2025
Time: 6:00 PM – 10:00 PM
Venue: Grand Ballroom, Hilton Hotel

Highlights of the Evening:
✔ Award ceremony recognizing <mark>우수한</mark> employees
✔ Dinner and <mark>라이브 공연</mark>
✔ <mark>경품 추첨</mark> with exciting prizes

Important Notes:

Attendance is free, but employees must <mark>참석 여부</mark> by April 12 at events@company.com.
Employees may <mark>동반</mark> one guest.
<mark>비즈니스 캐주얼 복장</mark> is required.
We look forward to celebrating with you! If you have any questions, please contact the HR department.

Best regards,
HR Department`,

  wordPairs: {
    "Employee Appreciation": "직원 감사",
    dedication: "헌신",
    outstanding: "우수한",
    "live entertainment": "라이브 공연",
    "Lucky draw": "경품 추첨",
    RSVP: "참석 여부",
    bring: "동반",
    "Business casual attire": "비즈니스 캐주얼 복장",
  },

  questions: [],
};

const memo11 = {
  id: 11,
  passage: `Subject: <mark>Implementation</mark> of New <mark>Employee Attendance System</mark>
To: All Employees
From: IT Department
Date: October 1, 2025

Dear Employees,

We are pleased to announce the implementation of a new Employee Attendance System, which will <mark>go live</mark> on October 15, 2025. This system will improve efficiency and <mark>accuracy</mark> in <mark>tracking</mark> work hours.

Key Features:

Employees will <mark>clock in</mark> and out using their ID badges.
<mark>Attendance records</mark> will be automatically <mark>logged in</mark> the HR system.
<mark>Remote employees</mark> can check in <mark>via</mark> the company intranet portal.

Action Required:

Employees must complete the training session on the new system by October 12.
Detailed user manuals and training videos will be <mark>available</mark> on the company intranet.

Support:
For technical assistance, please contact the IT helpdesk at it.support@company.com.

We appreciate your cooperation in making this <mark>transition</mark> <mark>smooth</mark>.

Best regards,
IT Department`,

  translation: `제목: 새로운 직원 출결 시스템 도입
수신: 전 직원
발신: IT 부서
날짜: 2025년 10월 1일

직원 여러분,

2025년 10월 15일부터 시행될 새로운 직원 출결 시스템 도입을 알려드리게 되어 기쁩니다. 이 시스템은 근무 시간 추적의 효율성과 정확성을 향상시킬 것입니다.

주요 기능:

직원들은 ID 배지를 사용하여 출퇴근 체크를 하게 됩니다.
출결 기록은 HR 시스템에 자동으로 기록됩니다.
재택근무 직원들은 회사 인트라넷 포털을 통해 체크인할 수 있습니다.

필요한 조치:

직원들은 10월 12일까지 새로운 시스템에 대한 교육을 이수해야 합니다.
상세 사용자 매뉴얼과 교육 영상이 회사 인트라넷에서 제공될 예정입니다.

지원:
기술적 지원이 필요한 경우 IT 헬프데스크(it.support@company.com)로 문의해 주시기 바랍니다.

원활한 전환을 위해 협조해 주셔서 감사합니다.

감사합니다.
IT 부서 드림`,
  koreanNouns: `Subject: <mark>도입</mark> of New <mark>직원 출결 시스템</mark>
To: All Employees
From: IT Department
Date: October 1, 2025

Dear Employees,

We are pleased to announce the implementation of a new Employee Attendance System, which will <mark>시행</mark> on October 15, 2025. This system will improve efficiency and <mark>정확성</mark> in <mark>추적</mark> work hours.

Key Features:

Employees will <mark>출퇴근 체크</mark> and out using their ID badges.
<mark>출결 기록</mark> will be automatically <mark>기록</mark> the HR system.
<mark>재택근무 직원</mark> can check in <mark>통해</mark> the company intranet portal.

Action Required:

Employees must complete the training session on the new system by October 12.
Detailed user manuals and training videos will be <mark>제공</mark> on the company intranet.

Support:
For technical assistance, please contact the IT helpdesk at it.support@company.com.

We appreciate your cooperation in making this <mark>전환</mark> <mark>원활한</mark>.

Best regards,
IT Department`,

  wordPairs: {
    Implementation: "도입",
    "Employee Attendance System": "직원 출결 시스템",
    "go live": "정식 개시",
    accuracy: "정확성",
    tracking: "추적",
    "clock in": "출퇴근 체크",
    "Attendance records": "출결 기록",
    "logged in": "기록",
    "Remote employees": "재택근무 직원",
    via: "통해",
    available: "제공",
    transition: "전환",
    smooth: "원활한",
  },

  questions: [],
};

const memo12 = {
  id: 12,
  passage: `Subject: Office Relocation Announcement
To: All Employees
From: <mark>Facilities Management</mark> Department
Date: October 5, 2025

Dear Team,

We are pleased to inform you that our company <mark>headquarters</mark> will be relocating to a new office building to <mark>accommodate</mark> our growing team and provide a better working environment.

New Office Details:

Address: 1250 Westwood Blvd, Suite 500, Los Angeles, CA
Move-in Date: Monday, November 3, 2025
New Office Features: Larger workspaces, upgraded conference rooms, and improved employee <mark>lounge</mark> areas
Important Information:

The last working day at the current office will be Friday, October 31.
Employees should <mark>pack</mark> personal items and <mark>label</mark> their boxes by October 29.
IT equipment and office furniture will be moved by a professional relocation team.
If you have any questions or require assistance, please contact facilities@company.com.

Best regards,
Facilities Management Team`,

  translation: `제목: 사무실 이전 공지
수신: 전 직원
발신: 시설 관리부
날짜: 2025년 10월 5일

팀원 여러분,

성장하는 팀을 수용하고 더 나은 근무 환경을 제공하기 위해 본사가 새로운 사무실 건물로 이전할 예정임을 알려드립니다.

새 사무실 세부사항:

주소: 1250 Westwood Blvd, Suite 500, Los Angeles, CA
입주일: 2025년 11월 3일 월요일
새 사무실 특징: 더 넓은 업무 공간, 업그레이드된 회의실, 개선된 직원 휴게 공간
중요 정보:

현재 사무실에서의 마지막 근무일은 10월 31일 금요일입니다.
직원들은 10월 29일까지 개인 물품을 포장하고 박스에 라벨을 부착해야 합니다.
IT 장비와 사무실 가구는 전문 이사팀이 옮길 예정입니다.
문의사항이나 도움이 필요하시면 facilities@company.com으로 연락 주시기 바랍니다.

감사합니다.
시설 관리팀 드림`,

  koreanNouns: `Subject: Office Relocation Announcement
To: All Employees
From: <mark>시설 관리</mark> Department
Date: October 5, 2025

Dear Team,

We are pleased to inform you that our company <mark>본사</mark> will be relocating to a new office building to <mark>수용하다</mark> our growing team and provide a better working environment.

New Office Details:

Address: 1250 Westwood Blvd, Suite 500, Los Angeles, CA
Move-in Date: Monday, November 3, 2025
New Office Features: Larger workspaces, upgraded conference rooms, and improved employee <mark>휴게</mark> areas
Important Information:

The last working day at the current office will be Friday, October 31.
Employees should <mark>포장하다</mark> personal items and <mark>라벨 부착하다</mark> their boxes by October 29.
IT equipment and office furniture will be moved by a professional relocation team.
If you have any questions or require assistance, please contact facilities@company.com.

Best regards,
Facilities Management Team`,

  wordPairs: {
    "Facilities Management": "시설 관리",
    headquarters: "본사",
    accommodate: "수용하다",
    lounge: "휴게",
    pack: "포장하다",
    label: "라벨 부착하다",
  },

  questions: [],
};
const memo13 = {
  id: 13,
  passage: `Subject: Update to <mark>Employee Benefits Program</mark>
To: All Employees
From: <mark>Human Resources Department</mark>
Date: July 15, 2025

Dear Employees,

As part of our <mark>commitment</mark> to employee well-being, we are enhancing our <mark>benefits program</mark> to provide additional support and resources. The <mark>following</mark> changes will take effect starting August 1, 2025.

Key Benefits Updates:
-Increased Health Coverage: The company will now cover 80% of medical expenses, up from 70%.
-Additional <mark>Paid Leave</mark>: Employees will receive two extra vacation days per year.
-Gym Membership <mark>Reimbursement</mark>: Employees can be <mark>reimbursed</mark> up to $50 per month for gym memberships.

What You Need to Do:
-Employees who wish to update their health insurance plans must submit their request <mark>via</mark> the HR portal by July 31.
-For gym reimbursement, employees must submit proof of payment each month.
-For further details, please visit the HR section on the company intranet or contact benefits@company.com.

Best regards,
HR Department`,

  translation: `제목: 직원 복리후생 프로그램 업데이트
수신: 전 직원
발신: 인사부
날짜: 2025년 7월 15일

직원 여러분,

직원 복지 향상을 위한 노력의 일환으로, 추가적인 지원과 자원을 제공하기 위해 복리후생 프로그램을 개선하고 있습니다. 다음의 변경사항들은 2025년 8월 1일부터 적용됩니다.

주요 복리후생 업데이트:

의료보험 보장 확대: 회사가 의료비의 70%에서 80%로 보장 범위를 확대합니다.
추가 유급휴가: 직원들은 연간 2일의 추가 휴가를 받게 됩니다.
헬스장 회원권 환급: 직원들은 헬스장 회원권에 대해 월 최대 50달러까지 환급받을 수 있습니다.
필요한 조치:

의료보험 플랜을 업데이트하고자 하는 직원들은 7월 31일까지 HR 포털을 통해 신청서를 제출해야 합니다.
헬스장 환급을 위해서는 매월 결제 증빙을 제출해야 합니다.
자세한 내용은 회사 인트라넷의 HR 섹션을 방문하거나 benefits@company.com으로 문의해 주시기 바랍니다.

감사합니다.
인사부 드림`,

  koreanNouns: `Subject: Update to <mark>직원 복리후생 프로그램</mark>
To: All Employees
From: <mark>인사부</mark>
Date: July 15, 2025

Dear Employees,

As part of our <mark>헌신</mark> to employee well-being, we are enhancing our <mark>복리후생 프로그램</mark> to provide additional support and resources. The <mark>다음</mark> changes will take effect starting August 1, 2025.

Key Benefits Updates:
-Increased Health Coverage: The company will now cover 80% of medical expenses, up from 70%.
-Additional <mark>유급 휴가</mark>: Employees will receive two extra vacation days per year.
-Gym Membership <mark>환급</mark>: Employees can be reimbursed up to $50 per month for gym memberships.

What You Need to Do:
-Employees who wish to update their health insurance plans must submit their request <mark>통해</mark> the HR portal by July 31.
-For gym reimbursement, employees must submit proof of payment each month.
-For further details, please visit the HR section on the company intranet or contact benefits@company.com.

Best regards,
HR Department`,

  wordPairs: {
    "Employee Benefits Program": "직원 복리후생 프로그램",
    "benefits program": "복리후생 프로그램",
    "Human Resources Department": "인사부",
    commitment: "헌신",
    following: "다음",
    "Paid Leave": "유급 휴가",
    Reimbursement: "환급",
    via: "통해",
  },

  questions: [],
};

const memo14 = {
  id: 14,
  passage: `Subject: Revised Order Processing Procedure
To: All Sales Representatives
From: Operations Department
Date: March 12, 2025

Dear Sales Representatives,

Effective March 18, 2025, all sales representatives must <mark>adhere to</mark> the updated order processing procedure to ensure <mark>greater</mark> accuracy in inventory management and delivery scheduling. Moving forward, all customer orders must be entered into the new Centralized Order Management System (COMS), replacing the previous manual entry system. Once an order is submitted, it will require approval from the Regional Sales Supervisor before being processed by the <mark>fulfillment</mark> team.

Additionally, sales representatives are required to verify customer details and confirm stock availability before finalizing <mark>transactions</mark>. Any order discrepancies or modifications must be reported to the Operations Department within 24 hours of submission. Failure to follow the new procedure may result in processing delays or order cancellations.

To assist with the <mark>transition</mark>, <mark>mandatory</mark> training sessions on the COMS platform will be held from March 14 to March 16, 2025. Attendance is required, and employees who fail to complete the training will not have access to the system starting March 18. For further details, please contact the Operations Department at operations@company.com.

Best regards,
Operations Department`,

  translation: `제목: 주문 처리 절차 개정
수신: 전체 영업 담당자
발신: 운영부
날짜: 2025년 3월 12일

영업 담당자 여러분,

2025년 3월 18일부터 재고 관리와 배송 일정의 정확성을 높이기 위해 모든 영업 담당자는 업데이트된 주문 처리 절차를 준수해야 합니다. 앞으로 모든 고객 주문은 기존의 수동 입력 시스템을 대체하는 새로운 중앙집중식 주문 관리 시스템(COMS)에 입력되어야 합니다. 주문이 제출되면 이행팀이 처리하기 전에 지역 영업 감독자의 승인이 필요합니다.

또한, 영업 담당자는 거래를 완료하기 전에 고객 정보를 확인하고 재고 가용성을 확인해야 합니다. 주문 불일치나 수정 사항은 제출 후 24시간 이내에 운영부에 보고해야 합니다. 새로운 절차를 따르지 않을 경우 처리 지연이나 주문 취소가 발생할 수 있습니다.

전환을 돕기 위해 2025년 3월 14일부터 16일까지 COMS 플랫폼에 대한 필수 교육 세션이 진행됩니다. 참석은 필수이며, 교육을 이수하지 않은 직원은 3월 18일부터 시스템에 접근할 수 없습니다. 자세한 내용은 operations@company.com으로 운영부에 문의하시기 바랍니다.

감사합니다.
운영부 드림`,

  koreanNouns: `Subject: Revised Order Processing Procedure
To: All Sales Representatives
From: Operations Department
Date: March 12, 2025

Dear Sales Representatives,

Effective March 18, 2025, all sales representatives must <mark>준수하다</mark> the updated order processing procedure to ensure <mark>더 높은</mark> accuracy in inventory management and delivery scheduling. Moving forward, all customer orders must be entered into the new Centralized Order Management System (COMS), replacing the previous manual entry system. Once an order is submitted, it will require approval from the Regional Sales Supervisor before being processed by the <mark>이행</mark> team.

Additionally, sales representatives are required to verify customer details and confirm stock availability before finalizing <mark>거래</mark>. Any order discrepancies or modifications must be reported to the Operations Department within 24 hours of submission. Failure to follow the new procedure may result in processing delays or order cancellations.

To assist with the <mark>전환</mark>, <mark>필수</mark> training sessions on the COMS platform will be held from March 14 to March 16, 2025. Attendance is required, and employees who fail to complete the training will not have access to the system starting March 18. For further details, please contact the Operations Department at operations@company.com.

Best regards,
Operations Department`,

  wordPairs: {
    "adhere to": "준수하다",
    greater: "더 높은",
    fulfillment: "이행",
    transactions: "거래",
    transition: "전환",
    mandatory: "필수",
  },

  questions: [],
};
const memo15 = {
  id: 15,
  passage: `Subject: Temporary Service Interruption Notice
To: All Customers
From: Customer Support Team
Date: June 5, 2025

Dear Customers,

We regret to inform you that due to an unexpected system failure, our online payment processing service will be temporarily unavailable starting June 6, 2025, at 10:00 AM (PST). Our technical team is working <mark>diligently</mark> to resolve the issue, and we anticipate that full service will be restored by June 7, 2025, at 8:00 PM (PST).

During this period, customers will be unable to complete online transactions, including bill payments, fund transfers, and subscription renewals. However, in-person transactions at our physical locations will remain unaffected. Customers who need to make urgent payments are advised to use alternative payment methods such as bank transfers or in-store payments.

We sincerely apologize for any inconvenience this may cause. As a token of appreciation for your patience, we will be <mark>waiving</mark> any late fees <mark>incurred</mark> due to this <mark>disruption</mark>. If you experience any further difficulties after the <mark>restoration</mark> period, please contact our Customer Support Team at support@company.com or call (800) 555-7070.

Thank you for your understanding and cooperation.

Best regards,
Customer Support Team`,

  translation: `제목: 임시 서비스 중단 안내
수신: 전체 고객
발신: 고객 지원팀
날짜: 2025년 6월 5일

고객 여러분,

예기치 않은 시스템 장애로 인해 2025년 6월 6일 오전 10시(PST)부터 온라인 결제 처리 서비스가 일시적으로 중단될 예정임을 알려드립니다. 기술팀이 문제 해결을 위해 최선을 다하고 있으며, 2025년 6월 7일 오후 8시(PST)까지 전체 서비스가 복구될 것으로 예상됩니다.

이 기간 동안 고객님들은 청구서 결제, 자금 이체, 구독 갱신을 포함한 온라인 거래를 완료할 수 없습니다. 단, 실제 매장에서의 대면 거래는 영향을 받지 않습니다. 긴급한 결제가 필요한 고객님들은 은행 이체나 매장 내 결제와 같은 대체 결제 방법을 이용하시기 바랍니다.

불편을 끼쳐 진심으로 사과드립니다. 고객님들의 양해에 감사드리는 의미로, 이번 중단으로 인해 발생하는 모든 연체료는 면제해 드립니다. 서비스 복구 후에도 어려움이 있으시다면 support@company.com으로 고객 지원팀에 문의하시거나 (800) 555-7070으로 전화해 주시기 바랍니다.

양해와 협조에 감사드립니다.

감사합니다.
고객 지원팀 드림`,

  koreanNouns: `Subject: Temporary Service Interruption Notice
To: All Customers
From: Customer Support Team
Date: June 5, 2025

Dear Customers,

We regret to inform you that due to an unexpected system failure, our online payment processing service will be temporarily unavailable starting June 6, 2025, at 10:00 AM (PST). Our technical team is working <mark>성실하게</mark> to resolve the issue, and we anticipate that full service will be restored by June 7, 2025, at 8:00 PM (PST).

During this period, customers will be unable to complete online transactions, including bill payments, fund transfers, and subscription renewals. However, in-person transactions at our physical locations will remain unaffected. Customers who need to make urgent payments are advised to use alternative payment methods such as bank transfers or in-store payments.

We sincerely apologize for any inconvenience this may cause. As a token of appreciation for your patience, we will be <mark>면제하다</mark> any late fees <mark>발생한</mark> due to this <mark>중단</mark>. If you experience any further difficulties after the <mark>복구</mark> period, please contact our Customer Support Team at support@company.com or call (800) 555-7070.

Thank you for your understanding and cooperation.

Best regards,
Customer Support Team`,

  wordPairs: {
    diligently: "성실하게",
    waiving: "면제하다",
    incurred: "발생한",
    disruption: "중단",
    restoration: "복구",
  },

  questions: [],
};

const memo16 = {
  id: 16,
  passage: `Subject: Urgent: Security Breach Notification & Required Action
To: All Customers
From: IT Security Department
Date: September 10, 2025

Dear Customers,

We regret to inform you that our system recently <mark>detected</mark> unauthorized access to a limited number of customer accounts on September 9, 2025. While our security team has <mark>contained</mark> the issue and reinforced our protective <mark>measures</mark>, we urge all users to take immediate action to <mark>safeguard</mark> their accounts.

Although there is no evidence that sensitive financial information was <mark>compromised</mark>, some personal details, such as names, email addresses, and phone numbers, may have been accessed. As a <mark>precaution</mark>, we strongly recommend that all customers reset their passwords immediately and enable two-factor authentication (2FA) for additional security.

To reset your password, please visit www.company.com/security-update and follow the instructions provided. If you notice any <mark>suspicious</mark> activity on your account, contact our Security Response Team at security@company.com or call (800) 555-8080.

We sincerely apologize for any inconvenience this may cause and assure you that we are implementing enhanced security protocols to prevent future <mark>incidents</mark>. Thank you for your prompt attention to this matter.

Best regards,
IT Security Department`,

  translation: `제목: 긴급: 보안 침해 알림 및 필수 조치 사항
수신: 전체 고객
발신: IT 보안부
날짜: 2025년 9월 10일

고객 여러분,

2025년 9월 9일, 일부 고객 계정에 대한 무단 접근이 시스템에서 감지되었음을 알려드립니다. 보안팀이 문제를 통제하고 보호 조치를 강화했지만, 모든 사용자께서는 계정 보호를 위해 즉각적인 조치를 취해주시기 바랍니다.

민감한 금융 정보가 유출되었다는 증거는 없으나, 이름, 이메일 주소, 전화번호와 같은 일부 개인 정보가 접근되었을 수 있습니다. 예방 차원에서 모든 고객님들께서는 즉시 비밀번호를 재설정하고 추가 보안을 위해 2단계 인증(2FA)을 활성화하시기를 강력히 권장드립니다.

비밀번호 재설정을 위해서는 www.company.com/security-update를 방문하여 안내된 지침을 따라주시기 바랍니다. 계정에서 의심스러운 활동을 발견하신 경우, security@company.com으로 보안 대응팀에 문의하시거나 (800) 555-8080으로 전화해 주시기 바랍니다.

불편을 끼쳐 진심으로 사과드리며, 향후 이러한 사고를 방지하기 위해 강화된 보안 프로토콜을 구현하고 있음을 알려드립니다. 신속한 조치에 감사드립니다.

감사합니다.
IT 보안부 드림`,

  koreanNouns: `Subject: Urgent: Security Breach Notification & Required Action
To: All Customers
From: IT Security Department
Date: September 10, 2025

Dear Customers,

We regret to inform you that our system recently <mark>감지됬다</mark> unauthorized access to a limited number of customer accounts on September 9, 2025. While our security team has <mark>통제했다</mark> the issue and reinforced our protective <mark>조치</mark>, we urge all users to take immediate action to <mark>보호</mark> their accounts.

Although there is no evidence that sensitive financial information was <mark>유출된</mark>, some personal details, such as names, email addresses, and phone numbers, may have been accessed. As a <mark>예방조치</mark>, we strongly recommend that all customers reset their passwords immediately and enable two-factor authentication (2FA) for additional security.

To reset your password, please visit www.company.com/security-update and follow the instructions provided. If you notice any <mark>의심스러운</mark> activity on your account, contact our Security Response Team at security@company.com or call (800) 555-8080.

We sincerely apologize for any inconvenience this may cause and assure you that we are implementing enhanced security protocols to prevent future <mark>사고</mark>. Thank you for your prompt attention to this matter.

Best regards,
IT Security Department`,

  wordPairs: {
    detected: "감지됬다",
    contained: "통제했다",
    measures: "조치",
    safeguard: "보호",
    compromised: "유출된",
    precaution: "예방조치",
    suspicious: "의심스러운",
    incidents: "사고",
  },

  questions: [],
};

const memo17 = {
  id: 17,
  passage: `Subject: Organizational Changes Following Corporate <mark>merger</mark>
To: All Employees
From: Executive Management
Date: November 5, 2025

We are pleased to announce that our company has successfully merged with Weston Technologies, a leader in cloud-based enterprise solutions. This strategic merger will allow us to expand our service <mark>offerings</mark> and <mark>strengthen</mark> our position in the global market.

As part of the integration process, there will be several organizational <mark>realignments</mark>. Effective December 1, 2025, some departments will be <mark>consolidated</mark> to improve operational efficiency. While most roles will remain unchanged, certain employees may be reassigned to different teams based on business needs. Affected employees will receive further details from the Human Resources Department by November 15, 2025.

Additionally, we are introducing a new performance-based incentive structure, which will be implemented <mark>company-wide</mark> starting January 2026. More information regarding compensation adjustments will be provided during upcoming departmental briefings.

We understand that transitions like these may bring questions or concerns. To ensure a smooth transition, we will be holding a company-wide town hall meeting on November 10, 2025, where <mark>executives</mark> will address key aspects of the merger and answer employee questions.

If you have any immediate concerns, please reach out to HR@company.com.

Executive Management`,

  translation: `제목: 기업 합병에 따른 조직 변경
수신: 전체 직원
발신: 경영진
날짜: 2025년 11월 5일

당사가 클라우드 기반 기업 솔루션 분야의 선두 기업인 Weston Technologies와 성공적으로 합병하게 되었음을 기쁘게 알려드립니다. 이번 전략적 합병을 통해 우리는 서비스 제공 범위를 확대하고 글로벌 시장에서의 입지를 강화할 수 있게 될 것입니다.

통합 과정의 일환으로, 몇 가지 조직 개편이 있을 예정입니다. 2025년 12월 1일부터 운영 효율성 향상을 위해 일부 부서가 통합될 것입니다. 대부분의 역할은 변동이 없겠지만, 사업상 필요에 따라 일부 직원들은 다른 팀으로 재배치될 수 있습니다. 해당 직원들은 2025년 11월 15일까지 인사부서로부터 자세한 내용을 전달받게 될 것입니다.

또한, 2026년 1월부터 전사적으로 시행될 새로운 성과 기반 인센티브 구조를 도입할 예정입니다. 보상 조정에 관한 자세한 정보는 향후 부서별 브리핑에서 제공될 예정입니다.

이러한 변화 과정에서 질문이나 우려사항이 있을 수 있음을 이해하고 있습니다. 원활한 전환을 위해 2025년 11월 10일에 전사 타운홀 미팅을 개최하여 경영진이 합병의 주요 사항을 설명하고 직원들의 질문에 답변할 예정입니다.

긴급한 문의사항이 있으시면 HR@company.com으로 연락 주시기 바랍니다.

경영진 드림`,
  koreanNouns: `Subject: Organizational Changes Following Corporate <mark>합병</mark>
To: All Employees
From: Executive Management
Date: November 5, 2025

We are pleased to announce that our company has successfully merged with Weston Technologies, a leader in cloud-based enterprise solutions. This strategic merger will allow us to expand our service <mark>제공 서비스</mark> and <mark>강화하다</mark> our position in the global market.

As part of the integration process, there will be several organizational <mark>개편</mark>. Effective December 1, 2025, some departments will be <mark>통합된</mark> to improve operational efficiency. While most roles will remain unchanged, certain employees may be reassigned to different teams based on business needs. Affected employees will receive further details from the Human Resources Department by November 15, 2025.

Additionally, we are introducing a new performance-based incentive structure, which will be implemented <mark>회사 전반적으로</mark> starting January 2026. More information regarding compensation adjustments will be provided during upcoming departmental briefings.

We understand that transitions like these may bring questions or concerns. To ensure a smooth transition, we will be holding a company-wide town hall meeting on November 10, 2025, where <mark>경영진</mark> will address key aspects of the merger and answer employee questions.

If you have any immediate concerns, please reach out to HR@company.com.

Executive Management`,

  wordPairs: {
    merger: "합병",
    offerings: "제공 서비스",
    strengthen: "강화하다",
    realignments: "개편",
    consolidated: "통합된",
    "company-wide": "회사 전반적으로",
    executives: "경영진",
  },

  questions: [],
};

const memo18 = {
  id: 18,
  passage: `Subject: Supply Chain Disruptions Affecting Product Deliveries
To: All Regional Distributors & Retail Partners
From: Logistics & Operations Department
Date: October 3, 2025

We regret to inform you that due to unexpected <mark>disruptions</mark> in global supply chains, there will be delays in product shipments affecting several key markets. The ongoing <mark>port congestion</mark>, raw material <mark>shortages</mark>, and transportation delays have significantly impacted our production schedules and order <mark>fulfillment</mark> timelines.

As a result, estimated delivery times for certain products, particularly electronics and home appliances, will be extended by approximately two to three weeks. Customers who have already placed orders will receive automatic notifications with updated estimated delivery dates.

To mitigate the impact of these delays, we are implementing the following measures:

Prioritizing shipments for high-demand inventory
Expanding partnerships with <mark>alternative</mark> logistics providers
Adjusting production schedules to optimize available resources

We understand that these disruptions may affect your inventory planning and sales forecasts, and we appreciate your patience as we work to resolve these issues. If you require further assistance, please contact the Logistics Support Team at logistics@company.com.

Logistics & Operations Department`,

  translation: `제목: 제품 배송에 영향을 미치는 공급망 차질
수신: 모든 지역 유통업체 및 소매 파트너
발신: 물류 운영부
날짜: 2025년 10월 3일

글로벌 공급망의 예기치 않은 차질로 인해 여러 주요 시장에 영향을 미치는 제품 배송 지연이 있을 것임을 알려드리게 되어 유감입니다. 현재 진행 중인 항만 혼잡, 원자재 부족, 운송 지연이 당사의 생산 일정과 주문 이행 일정에 상당한 영향을 미쳤습니다.

그 결과, 특히 전자제품과 가전제품의 예상 배송 시간이 약 2-3주 연장될 예정입니다. 이미 주문하신 고객들께는 업데이트된 예상 배송 날짜와 함께 자동 알림이 발송될 것입니다.

이러한 지연의 영향을 완화하기 위해 다음과 같은 조치를 시행하고 있습니다:

수요가 많은 재고의 배송 우선순위 지정
대체 물류 제공업체와의 파트너십 확대
가용 자원을 최적화하기 위한 생산 일정 조정

이러한 차질이 귀사의 재고 계획과 판매 예측에 영향을 미칠 수 있음을 이해하고 있으며, 이러한 문제를 해결하는 동안 보여주신 인내에 감사드립니다. 추가 지원이 필요하신 경우 logistics@company.com으로 물류 지원팀에 문의해 주시기 바랍니다.

물류 운영부 드림`,

  koreanNouns: `Subject: Supply Chain Disruptions Affecting Product Deliveries
To: All Regional Distributors & Retail Partners
From: Logistics & Operations Department
Date: October 3, 2025

We regret to inform you that due to unexpected <mark>차질</mark> in global supply chains, there will be delays in product shipments affecting several key markets. The ongoing <mark>항만 혼잡</mark>, raw material <mark>부족</mark>, and transportation delays have significantly impacted our production schedules and order <mark>이행</mark> timelines.

As a result, estimated delivery times for certain products, particularly electronics and home appliances, will be extended by approximately two to three weeks. Customers who have already placed orders will receive automatic notifications with updated estimated delivery dates.

To mitigate the impact of these delays, we are implementing the following measures:

Prioritizing shipments for high-demand inventory
Expanding partnerships with <mark>대체</mark> logistics providers
Adjusting production schedules to optimize available resources

We understand that these disruptions may affect your inventory planning and sales forecasts, and we appreciate your patience as we work to resolve these issues. If you require further assistance, please contact the Logistics Support Team at logistics@company.com.

Logistics & Operations Department`,

  wordPairs: {
    disruptions: "차질",
    "port congestion": "항만 혼잡",
    shortages: "부족",
    fulfillment: "이행",
    alternative: "대체",
  },

  questions: [],
};
const memo19 = {
  id: 19,
  passage: `Subject: Revised Trade Regulations Impacting International Shipments
To: All Export & Logistics Teams
From: Global Trade Compliance Department
Date: May 12, 2025

We would like to inform all employees involved in international trade and logistics that recent changes in government trade policies may affect our <mark>import and export operations</mark>. Effective June 1, 2025, new <mark>tariffs</mark> and customs regulations will be <mark>imposed on</mark> shipments to and from certain regions, particularly Southeast Asia and the European Union. These regulatory updates may result in higher shipping costs, extended <mark>customs clearance</mark> times, and additional documentation requirements.

To ensure compliance and minimize disruptions, all export teams must:

Verify updated <mark>tariff</mark> rates before finalizing shipments
Submit revised customs <mark>declarations</mark> reflecting the new <mark>duties</mark>
Coordinate with freight forwarders to prevent delays at ports of entry

Additionally, shipments containing restricted electronic components will be subject to additional inspections, and failure to provide accurate documentation may result in shipment holds or penalties.

All employees handling international trade must complete the mandatory compliance training session by May 25, 2025, to ensure full <mark>adherence to</mark> the revised policies. If you have any concerns or require clarification, please contact the Global Trade Compliance Team at tradecompliance@company.com.

Global Trade Compliance Department`,

  translation: `제목: 국제 운송에 영향을 미치는 개정된 무역 규정
수신: 모든 수출 및 물류팀
발신: 글로벌 무역 규정준수부
날짜: 2025년 5월 12일

국제 무역 및 물류 관련 모든 직원들에게 최근 정부 무역 정책의 변경이 당사의 수출입 업무에 영향을 미칠 수 있음을 알려드립니다. 2025년 6월 1일부터 특히 동남아시아와 유럽연합을 대상으로 하는 운송에 새로운 관세와 통관 규정이 적용될 예정입니다. 이러한 규정 업데이트로 인해 운송 비용 상승, 통관 시간 연장, 추가 서류 요구사항이 발생할 수 있습니다.

규정 준수를 보장하고 차질을 최소화하기 위해 모든 수출팀은 다음 사항을 준수해야 합니다:

선적 완료 전 업데이트된 관세율 확인
새로운 관세를 반영한 수정된 통관 신고서 제출
입항지에서의 지연 방지를 위한 화물 운송업체와의 협력

또한, 제한된 전자 부품이 포함된 선적물은 추가 검사 대상이 되며, 정확한 서류를 제공하지 않을 경우 선적 보류나 벌금이 부과될 수 있습니다.

국제 무역을 담당하는 모든 직원은 개정된 정책을 완전히 준수하기 위해 2025년 5월 25일까지 필수 규정 준수 교육을 이수해야 합니다. 우려사항이나 명확한 설명이 필요한 경우 tradecompliance@company.com으로 글로벌 무역 규정준수팀에 문의해 주시기 바랍니다.

글로벌 무역 규정준수부 드림`,

  koreanNouns: `Subject: Revised Trade Regulations Impacting International Shipments
To: All Export & Logistics Teams
From: Global Trade Compliance Department
Date: May 12, 2025

We would like to inform all employees involved in international trade and logistics that recent changes in government trade policies may affect our <mark>수출입 업무</mark>. Effective June 1, 2025, new <mark>관세</mark> and customs regulations will be <mark>적용되다</mark> shipments to and from certain regions, particularly Southeast Asia and the European Union. These regulatory updates may result in higher shipping costs, extended <mark>통관</mark> times, and additional documentation requirements.

To ensure compliance and minimize disruptions, all export teams must:

Verify updated <mark>관세</mark> rates before finalizing shipments
Submit revised customs <mark>신고서</mark> reflecting the new <mark>관세</mark>
Coordinate with freight forwarders to prevent delays at ports of entry

Additionally, shipments containing restricted electronic components will be subject to additional inspections, and failure to provide accurate documentation may result in shipment holds or penalties.

All employees handling international trade must complete the mandatory compliance training session by May 25, 2025, to ensure full <mark>~에 대한 준수</mark> the revised policies. If you have any concerns or require clarification, please contact the Global Trade Compliance Team at tradecompliance@company.com.

Global Trade Compliance Department`,

  wordPairs: {
    "import and export operations": "수출입 업무",
    tariffs: "관세",
    "imposed on": "적용되다",
    "customs clearance": "통관",
    declarations: "신고서",
    duties: "관세",
    "adherence to": "	~에 대한 준수",
  },

  questions: [],
};

const memo20 = {
  id: 20,
  passage: `Subject: Setting Up the Brevona X3 Espresso Machine
To: All Staff Members
From: Office Management Team
Date: June 5, 2025

Thank you for purchasing the newly released Brevona X3 espresso machine! This model is carefully designed to provide consistently rich coffee while ensuring an exceptionally smooth brewing experience.

To begin, place the machine on a perfectly <mark>stable</mark> surface and <mark>securely</mark> attach the water <mark>reservoir</mark>. Then, fill the tank with adequately filtered water to maintain optimal flavor quality.

Before the first use, run a thorough cleaning cycle by pressing the clearly labeled rinse button. This step ensures that all components are properly <mark>sanitized</mark> and ready for brewing.

To prepare your espresso, insert a <mark>finely</mark> ground coffee pod into the designated slot and select your preferred settings. The machine will automatically adjust the temperature and pressure to deliver a perfectly balanced shot of espresso.

For long-term maintenance, <mark>descale</mark> the machine regularly using a specially formulated cleaning solution. Store the accessories in a conveniently accessible compartment to keep your workspace neatly organized.

By following these simple yet essential steps, you can enjoy exceptionally fresh espresso every day!

Office Management Team`,

  translation: `제목: Brevona X3 에스프레소 머신 설치하기
수신: 모든 직원
발신: 사무실 관리팀
날짜: 2025년 6월 5일

새로 출시된 Brevona X3 에스프레소 머신을 구매해 주셔서 감사합니다! 이 모델은 일관되게 풍부한 커피를 제공하면서 탁월하게 부드러운 추출 경험을 보장하도록 세심하게 설계되었습니다.

시작하려면, 머신을 완벽하게 안정된 표면에 놓고 물 저장통을 안전하게 부착하세요. 그런 다음, 최적의 맛 품질을 유지하기 위해 적절히 여과된 물로 탱크를 채우세요.

첫 사용 전에, 명확하게 표시된 헹굼 버튼을 눌러 철저한 세척 사이클을 실행하세요. 이 단계는 모든 구성 요소가 적절히 살균되고 추출 준비가 되었음을 보장합니다.

에스프레소를 준비하려면, 지정된 슬롯에 곱게 갈린 커피 포드를 삽입하고 원하는 설정을 선택하세요. 머신이 자동으로 온도와 압력을 조절하여 완벽하게 균형 잡힌 에스프레소 샷을 제공할 것입니다.

장기적인 유지 관리를 위해, 특별히 제조된 세척 용액을 사용하여 정기적으로 머신의 석회질을 제거하세요. 작업 공간을 깔끔하게 정리하기 위해 액세서리를 편리하게 접근할 수 있는 칸에 보관하세요.

이러한 간단하지만 필수적인 단계를 따르면, 매일 탁월하게 신선한 에스프레소를 즐길 수 있습니다!

사무실 관리팀 드림`,

  koreanNouns: `Subject: Setting Up the Brevona X3 Espresso Machine
To: All Staff Members
From: Office Management Team
Date: June 5, 2025

Thank you for purchasing the newly released Brevona X3 espresso machine! This model is carefully designed to provide consistently rich coffee while ensuring an exceptionally smooth brewing experience.

To begin, place the machine on a perfectly <mark>안정된</mark> surface and <mark>안전하게</mark> attach the water <mark>저장통</mark>. Then, fill the tank with adequately filtered water to maintain optimal flavor quality.

Before the first use, run a thorough cleaning cycle by pressing the clearly labeled rinse button. This step ensures that all components are properly <mark>살균되다</mark> and ready for brewing.

To prepare your espresso, insert a <mark>곱게</mark> ground coffee pod into the designated slot and select your preferred settings. The machine will automatically adjust the temperature and pressure to deliver a perfectly balanced shot of espresso.

For long-term maintenance, <mark>물때 제거하다</mark> the machine regularly using a specially formulated cleaning solution. Store the accessories in a conveniently accessible compartment to keep your workspace neatly organized.

By following these simple yet essential steps, you can enjoy exceptionally fresh espresso every day!

Office Management Team`,

  wordPairs: {
    stable: "안정된",
    securely: "안전하게",
    reservoir: "저장통",
    sanitized: "살균되다",
    finely: "곱게",
    descale: "물때 제거하다",
  },

  questions: [],
};
const memo21 = {
  id: 21,
  passage: `Subject: Scheduled Power Outage Notification
To: All Residents
From: Green Village Community Management
Date: August 5, 2055

Dear Residents,

We would like to inform you that there will be a temporary <mark>power outage</mark> due to scheduled maintenance. We apologize for any inconvenience this may cause and appreciate your understanding and cooperation.

Details of the Power Outage:
- Date: August 10, 2055
- Time: 9:00 AM to 2:00 PM
- Affected Areas: Building A, Building B, and Parking Garage Level 1

Please take necessary <mark>precautions</mark> and make <mark>appropriate</mark> arrangements during this time. We recommend that you:
- Unplug electronic devices to prevent damage from <mark>power surges</mark> when the power is restored.
- Keep your refrigerator and freezer doors closed as much as possible to maintain their temperature.
- Charge your mobile phones and any other essential devices in advance.

We are committed to ensuring minimal disruption and will complete the maintenance as <mark>swiftly</mark> as possible. Thank you for your patience and cooperation.

If you have any questions or require further information, please do not hesitate to contact our customer service team at (213) 555-8432 or email us at support@greenvillagecommunity.com.

Sincerely,
Green Village Community Management`,

  translation: `제목: 예정된 정전 안내
수신: 모든 거주자
발신: 그린 빌리지 커뮤니티 관리부
날짜: 2055년 8월 5일

거주자 여러분,

예정된 유지보수로 인한 일시적인 정전이 있을 예정임을 알려드립니다. 이로 인해 발생할 수 있는 불편에 대해 사과드리며, 여러분의 이해와 협조에 감사드립니다.

정전 세부 사항:
- 날짜: 2055년 8월 10일
- 시간: 오전 9시부터 오후 2시까지
- 영향 지역: A동, B동, 주차장 1층

이 기간 동안 필요한 예방 조치를 취하고 적절한 준비를 해주시기 바랍니다. 다음 사항을 권장합니다:
- 전원이 복구될 때 전력 서지로 인한 손상을 방지하기 위해 전자 기기의 플러그를 뽑아두세요.
- 냉장고와 냉동고의 온도를 유지하기 위해 문을 최대한 닫아두세요.
- 휴대폰 및 기타 필수 기기를 미리 충전해두세요.

저희는 최소한의 불편함을 보장하고 유지보수를 최대한 신속하게 완료하기 위해 최선을 다하고 있습니다. 여러분의 인내와 협조에 감사드립니다.

질문이 있거나 추가 정보가 필요하신 경우, (213) 555-8432로 고객 서비스팀에 연락하시거나 support@greenvillagecommunity.com으로 이메일을 보내주시기 바랍니다.

감사합니다,
그린 빌리지 커뮤니티 관리부`,

  koreanNouns: `Subject: Scheduled <mark>정전</mark> Notification
To: All Residents
From: Green Village Community Management
Date: August 5, 2055

Dear Residents,

We would like to inform you that there will be a temporary <mark>정전</mark> due to scheduled maintenance. We apologize for any inconvenience this may cause and appreciate your understanding and cooperation.

Details of the Power Outage:
- Date: August 10, 2055
- Time: 9:00 AM to 2:00 PM
- Affected Areas: Building A, Building B, and Parking Garage Level 1

Please take necessary <mark>예방 조치</mark> and make <mark>적절한</mark> arrangements during this time. We recommend that you:
- Unplug electronic devices to prevent damage from <mark>전력 급등</mark> when the power is restored.
- Keep your refrigerator and freezer doors closed as much as possible to maintain their temperature.
- Charge your mobile phones and any other essential devices in advance.

We are committed to ensuring minimal disruption and will complete the maintenance as <mark>신속하게</mark> as possible. Thank you for your patience and cooperation.

If you have any questions or require further information, please do not hesitate to contact our customer service team at (213) 555-8432 or email us at support@greenvillagecommunity.com.

Sincerely,
Green Village Community Management`,

  wordPairs: {
    "power outage": "정전",
    precautions: "예방 조치",
    appropriate: "적절한",
    "power surges": "전력 급등",
    swiftly: "신속하게",
  },

  questions: [],
};
const memo22 = {
  id: 22,
  passage: `Notice of remodeling Work at Maple Grove Residences

To: All Residents
From: Maple Grove Management Office
Date: March 26, 2025
Subject: Scheduled Refurbishment Work – April 8–19, 2025
Please be advised that <mark>refurbishment</mark> work will be carried out in the <mark>common</mark> areas of Maple Grove Residences from April 8 to April 19, 2025. The planned improvements include repainting of hallways, replacement of carpeting, and updates to <mark>lighting fixtures</mark>.

During this period, certain areas such as the main lobby and <mark>corridors</mark> on floors 2–5 may be temporarily inaccessible. Noise may occur between 9:00 A.M. and 5:00 P.M., Monday through Saturday. We kindly ask for your understanding and cooperation.

For safety reasons, please avoid walking through areas marked as "Under Maintenance," and follow all posted signs and staff instructions. The gym and laundry room will remain open as usual.

If you have any questions or concerns, please contact the management office at (555) 230-4432 or email us at info@maplegrove.com.

Thank you for your patience as we work to enhance your living environment.`,

  translation: `메이플 그로브 레지던스 리모델링 공사 안내

수신: 모든 거주자
발신: 메이플 그로브 관리 사무소
날짜: 2025년 3월 26일
제목: 예정된 리모델링 공사 – 2025년 4월 8일–19일

메이플 그로브 레지던스의 공용 구역에서 2025년 4월 8일부터 19일까지 리모델링 공사가 진행될 예정임을 알려드립니다. 계획된 개선 사항에는 복도 재도색, 카펫 교체, 조명 설비 업데이트가 포함됩니다.

이 기간 동안 메인 로비 및 2-5층 복도와 같은 특정 구역은 일시적으로 접근이 불가능할 수 있습니다. 소음은 월요일부터 토요일까지 오전 9시부터 오후 5시 사이에 발생할 수 있습니다. 여러분의 이해와 협조를 부탁드립니다.

안전상의 이유로 "공사 중"으로 표시된 구역을 통과하지 마시고, 모든 게시된 표지판과 직원 지시를 따라주시기 바랍니다. 체육관과 세탁실은 평소와 같이 이용 가능합니다.

질문이나 우려 사항이 있으시면 관리 사무소 (555) 230-4432로 연락하시거나 info@maplegrove.com으로 이메일을 보내주시기 바랍니다.

여러분의 주거 환경을 개선하기 위해 노력하는 동안 보여주신 인내심에 감사드립니다.`,

  koreanNouns: `Notice of <mark>개조</mark> Work at Maple Grove Residences

To: All Residents
From: Maple Grove Management Office
Date: March 26, 2025
Subject: Scheduled Refurbishment Work – April 8–19, 2025

Please be advised that refurbishment work will be carried out in the <mark>공동</mark> areas of Maple Grove Residences from April 8 to April 19, 2025. The planned improvements include repainting of <mark>복도</mark>, replacement of carpeting, and updates to <mark>조명 시설</mark>.

During this period, certain areas such as the main lobby and <mark>복도</mark> on floors 2–5 may be temporarily inaccessible. Noise may occur between 9:00 A.M. and 5:00 P.M., Monday through Saturday. We kindly ask for your understanding and cooperation.

For safety reasons, please avoid walking through areas marked as "Under Maintenance," and follow all posted signs and staff instructions. The gym and laundry room will remain open as usual.

If you have any questions or concerns, please contact the management office at (555) 230-4432 or email us at info@maplegrove.com.

Thank you for your patience as we work to enhance your living environment.`,

  wordPairs: {
    개조: "refurbishment",
    공동: "common",
    복도: "hallways",
    "조명 시설": "lighting fixtures",
    복도: "corridors",
  },

  questions: [],
};
const memo23 = {
  id: 23,
  passage: `Subject: Revision to Overtime Policy – Effective April 1, 2025

This is to inform all employees that changes to the staff overtime policy will take effect starting April 1, 2025. These updates have been made to improve <mark>fairness</mark>, <mark>transparency</mark>, and compliance with <mark>labor regulations</mark>.

Under the revised policy:
- Overtime must be pre-approved by a direct supervisor.
- <mark>Eligible</mark> overtime hours are those exceeding 40 hours per week.
- Approved overtime will be <mark>compensated</mark> at 1.5 times the regular hourly rate, in accordance with labor law.
- Any unauthorized overtime will not be compensated.

Employees are encouraged to monitor their schedules closely and communicate in advance if additional hours are anticipated.

For full policy details or if you have questions, please contact the HR Department at hr@novacorp.com or call extension 230.

We appreciate your cooperation and continued <mark>dedication</mark>.`,

  translation: `제목: 초과근무 정책 개정 – 2025년 4월 1일부터 시행

모든 직원들에게 2025년 4월 1일부터 직원 초과근무 정책에 변경사항이 적용됨을 알려드립니다. 이러한 업데이트는 공정성, 투명성 및 노동 규정 준수를 개선하기 위해 이루어졌습니다.

개정된 정책에 따라:

초과근무는 직속 상사의 사전 승인을 받아야 합니다.

주당 40시간을 초과하는 시간이 초과근무 대상 시간입니다.

승인된 초과근무는 노동법에 따라 정규 시급의 1.5배로 보상됩니다.

승인되지 않은 초과근무는 보상되지 않습니다.

직원들은 자신의 일정을 면밀히 모니터링하고 추가 시간이 예상되는 경우 사전에 소통할 것을 권장합니다.

전체 정책 세부사항이나 질문이 있으시면 hr@novacorp.com으로 인사부에 문의하시거나 내선 230번으로 전화해 주십시오.

여러분의 협조와 지속적인 헌신에 감사드립니다.`,

  koreanNouns: `Subject: Revision to Overtime Policy – Effective April 1, 2025

This is to inform all employees that changes to the staff overtime policy will take effect starting April 1, 2025. These updates have been made to improve <mark>공정성</mark>, <mark>투명성</mark>, and compliance with <mark>노동 규정</mark>.

Under the revised policy:
- Overtime must be pre-approved by a direct supervisor.
- <mark>해당되는</mark> overtime hours are those exceeding 40 hours per week.
- Approved overtime will be <mark>보상된다</mark> at 1.5 times the regular hourly rate, in accordance with labor law.
- Any unauthorized overtime will not be compensated.

Employees are encouraged to monitor their schedules closely and communicate in advance if additional hours are anticipated.

For full policy details or if you have questions, please contact the HR Department at hr@novacorp.com or call extension 230.

We appreciate your cooperation and continued <mark>헌신</mark>.`,

  wordPairs: {
    fairness: "공정성",
    transparency: "투명성",
    eligible: "해당되는",
    compensated: "보상된다",
    dedication: "헌신",
    "labor regulations": "노동 규정",
  },

  questions: [],
};

export const memoQuestions = [
  memo1,
  memo2,
  memo3,
  memo4,
  memo5,
  memo6,
  memo7,
  memo8,
  memo9,
  memo10,
  memo11,
  memo12,
  memo13,
  memo14,
  memo15,
  memo16,
  memo17,
  memo18,
  memo19,
  memo20,
  memo21,
  memo22,
  memo23,
];
